export const obj2LabelValue = <T extends string>(labelMap: Record<T, string>) =>
  Object.keys(labelMap).map((key) => ({
    label: labelMap[key as keyof typeof labelMap] as T,
    value: key,
  }));
